<template>
  <div class="bg-secondary-3 p-3 mt-3 rounded">
    <div class="row px-3">
      <div class="col-12 col-md-4">
        <span class="font-weight-normal text-gray font-14">
          Tipo de Documento:
        </span>
        <p class="font-16">{{ document.documentTypeName }}</p>
      </div>
      <div class="col-12 col-md-7">
        <span class="font-weight-normal text-gray font-14">
          Nombre de Documento:
        </span>
        <p class="font-16">{{ document.fileName }}</p>
      </div>
      <div class="col-12 col-md-1 text-right">
        <action-button
          class="mr-2 mt-2"
          i="fas fa-file-download"
          variant="success"
          @click="() => $emit('on-download', document.documentId)"
        />
        <action-button
          v-if="hasDeletePermission"
          class="mr-2 mt-2"
          i="fas fa-times-circle"
          variant="danger"
          @click="$emit('on-remove', document.documentId)"
        />
      </div>
    </div>
  </div>
</template>

<script>
import ActionButton from 'ActionButton';
export default {
  name: 'AmendmentDocumentRow',
  components: {
    ActionButton,
  },
  props: {
    document: {
      type: Object,
      required: true,
    },
    hasDeletePermission: {
      type: Boolean,
      default: false,
    },
  },
};
</script>

<style lang="scss" scoped></style>
